export enum MimeTypesEnum {
    CSV = 'text/csv',
    JPEG = 'image/jpeg',
    JSON = 'application/json',
    MSExcel = 'application/vnd.ms-excel',
    MSWord = 'application/msword',
    PKI = 'application/pkixcmp',
    X509Certificate = 'application/x-x509-ca-cert',
    XML = 'application/xml',
    Zip = 'application/zip',
    Pdf = 'application/pdf',
    Docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

}
